const MODIFY_SELECTED_ITEM = (state, { field, value }) => {
  state.selectedItem[field] = value;
};

export default MODIFY_SELECTED_ITEM;
